import {
  GET_CLEAR_AUTOCOMPLETE,
	GET_CLEAR_DIRECTION,
	GET_GEOCODE_REQUESTED,
  GET_GOOGLE_MAP_AUTOCOMPLETE_REQUESTED,
  GET_GOOGLE_MAP_DIRECTION_REQUESTED,
  GET_GOOGLE_MAP_PLACE_DETAILS_REQUESTED,
  GET_GOOGLE_NEARBY_SEARCH_REQUESTED,
  GET_LOCATIONCHECK_CLEAR,
  GET_LOCATIONCHECK_REQUESTED
} from "resources/actionTypes";

export function  getAutoComplete(data) {
  return {
    type: GET_GOOGLE_MAP_AUTOCOMPLETE_REQUESTED,
    payload: data,
  };
}
export function getNearBySearch(data) {
  return {
    type: GET_GOOGLE_NEARBY_SEARCH_REQUESTED,
    payload: data,
  };
}
export function getPlaceDetails(getPlaceDetails) {
  const data = getPlaceDetails
  return {
    type: GET_GOOGLE_MAP_PLACE_DETAILS_REQUESTED,
    payload: data,
  };
}
export function getDirection(getDirectionDetails) {
  const data = {
    destination: getDirectionDetails?.destination,
    origin: getDirectionDetails?.origin,
  };
  return {
    type: GET_GOOGLE_MAP_DIRECTION_REQUESTED,
    payload: data,
  };
}
export function getGeocode(data) {
  return {
    type: GET_GEOCODE_REQUESTED,
    payload: data,
  };
}
export function getClearAutocomplete(){
  return {
    type:GET_CLEAR_AUTOCOMPLETE,
  }
}
export function getClearDirection() {
  return {
    type: GET_CLEAR_DIRECTION,
  };
}

export function getLocationCheck(data) {
  return {
    type: GET_LOCATIONCHECK_REQUESTED,
    payload: data,
  };
}

export function getClearLocationCheck() {
  return {
    type: GET_LOCATIONCHECK_CLEAR,
  };
}